import * as XLSX from 'xlsx';

/**
 * Экспортирует данные в Excel файл
 * @param {Array} data - Массив объектов для экспорта
 * @param {Array} columns - Массив колонок с конфигурацией
 * @param {string} filename - Имя файла для экспорта
 */
export const exportToExcel = (data, columns, filename = 'export.xlsx') => {
  try {
    // Подготовка данных для экспорта
    const exportData = data.map(row => {
      const exportRow = {};
      columns.forEach(col => {
        // Пропускаем колонки без headerName или служебные
        if (!col.headerName || col.field === 'actions' || col.field === '__check__') {
          return;
        }

        // Получаем значение
        let value = row[col.field];

        // Применяем valueGetter если есть
        if (col.valueGetter) {
          value = col.valueGetter({ row });
        }

        // Применяем renderCell если есть (для форматирования)
        if (col.renderCell && typeof value !== 'object') {
          // Для простых значений оставляем как есть
        }

        exportRow[col.headerName] = value;
      });
      return exportRow;
    });

    // Создаем workbook и worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Настройка ширины колонок
    const colWidths = columns
      .filter(col => col.headerName && col.field !== 'actions' && col.field !== '__check__')
      .map(col => ({
        wch: Math.max(
          col.headerName.length,
          col.width ? col.width / 10 : 20
        )
      }));
    ws['!cols'] = colWidths;

    // Добавляем worksheet в workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Данные');

    // Сохраняем файл
    XLSX.writeFile(wb, filename);

    return true;
  } catch (error) {
    console.error('Ошибка экспорта в Excel:', error);
    return false;
  }
};
